module.exports = __webpack_public_path__ + "static/decima-nova-pro-regular-2beb4c57154a1026eaed852b91154c7b.woff";